/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import './fonts/Rijksoverheid/ROsanswebtextbold.ttf';
import './fonts/Rijksoverheid/ROsanswebtextregular.ttf';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { SnackbarProvider } from 'notistack';
import { Router } from 'react-router-dom';
import './index.css';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import history from './history';
import Backdrop from './components/backdrop/Backdrop';
import store from './redux/store';

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Backdrop blocking={true} />}>
      <SnackbarProvider maxSnack={3}>
        <Router history={history}>
          <App />
        </Router>
      </SnackbarProvider>
    </Suspense>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
